import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EqualtecService } from '../../services/equaltec.service';
@Component({
  selector: 'app-equaltec-container',
  templateUrl: './EqualtecContainer.component.html'
})
export class EqualtecContainer implements OnInit {

  public isDetail: boolean = false;
  public isFavorites: boolean = false;
  public isEvidence: boolean = false;
  public isSearch: boolean = false;
  public isLink: boolean = false;

  private subDetail: any;
  private subFavorites: any;
  private subEvidence: any;
  private subSearch: any;
  private subLink: any;

  constructor(
    public translate: TranslateService,
    private equaltecService: EqualtecService
  ) { }

  ngOnInit(): void {
    this.subDetail = this.equaltecService.isDetail.subscribe(val => {
      this.isDetail = val
    });
    this.subFavorites = this.equaltecService.isFavorites.subscribe(val => {
      this.isFavorites = val
    });
    this.subEvidence = this.equaltecService.isEvidence.subscribe(val => {
      this.isEvidence = val
    });
    this.subSearch = this.equaltecService.isSearch.subscribe(val => {
      this.isSearch = val
    });
    this.subLink = this.equaltecService.isLink.subscribe(val => {
      this.isLink = val
    });
  }

  ngOnDestroy() {
    this.subDetail.unsubscribe();
    this.subFavorites.unsubscribe();
    this.subEvidence.unsubscribe();
    this.subSearch.unsubscribe();
    this.subLink.unsubscribe();
  }

}
